export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9091.8f8f39ea.jpg";